import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { DriverSiteState, DriverSiteStore } from './driver-site.store';

@Injectable({ providedIn: 'root' })
export class DriverSiteQuery extends QueryEntity<DriverSiteState> {
  protected store: DriverSiteStore;

  constructor() {
    const store = inject(DriverSiteStore);

    super(store);

    this.store = store;
  }
}
